var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload-file',{ref:"uploadDialog"}),_c('sidebar-menu',{attrs:{"menu":_vm.menuItems,"collapsed":_vm.collapsed},on:{"toggle-collapse":_vm.onNavToggleCollapse,"item-click":_vm.onNavItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }